module.exports = __webpack_public_path__ + "img/SKMJ_protect1.a9ff5841.png";